import React from 'react';
import classnames from 'classnames';
import isObject from 'lodash/isObject';
import Row from '../tag/Row';
import Span from '../tag/Span';

export default function ObjectFieldTemplate(props) {
  const { idSchema, uiSchema, schema, properties } = props;

  function renderChild(field, schema = {}, properties = {}) {
    return field in schema
      ? properties.find((property) => property.name === field).content
      : console.warn(`Key '${field}' doesn't exist in the properties`, schema);
  }

  /*
  Render a title for the form. 
  
  Todo localization */
  function renderTitle(title) {
    return <span>{title}</span>;
  }

  function renderColumns(columns, rowIndex, depth) {
    return columns.map((column, colIndex) => {
      let content = null;
      if (column.field) {
        content = renderChild(column.field, schema.properties, properties);
      } else if (column.rows) {
        content = renderRows(column.rows, depth + 1);
      } else if (column.title) {
        content = renderTitle(column.title);
      }
      return (
        <Span
          className={column.className}
          len={column.col}
          key={`${idSchema.$id}-row-${depth}-${rowIndex}-column-${colIndex}`}
        >
          {content}
        </Span>
      );
    });
  }

  function renderRows(rows, depth) {
    return rows
      ? rows.map((row, rowIndex) => {
          return (
            <Row
              className={row.className}
              key={`${idSchema.$id}-row-${depth}-${rowIndex}`}
            >
              {renderColumns(row.columns, rowIndex, depth)}
            </Row>
          );
        })
      : null;
  }

  return <>{renderRows(uiSchema['ui:grid'], 1)}</>;
}
